import React from 'react';
import DownloadFilters from './filters/DownloadFilters';
import DownloadGrid from './grid/DownloadGrid';
import DownloadActionBar from './DownloadActionBar';

const DownloadApp = () => (<div>
	<DownloadFilters/>
	<DownloadGrid/>
	<DownloadActionBar/>

</div>);

export default DownloadApp;
